import * as React from "react";
const SvgFiRrSvg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-svg_svg__a)">
      <path
        fill="#062147"
        d="M19 0H5C2.243 0 0 2.243 0 5v14c0 2.757 2.243 5 5 5h8.515c1.87 0 3.628-.729 4.95-2.051l3.484-3.484A6.96 6.96 0 0 0 24 13.515V5c0-2.757-2.243-5-5-5M5 22c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3v8.515c0 .165-.032.323-.047.485H17c-1.654 0-3 1.346-3 3v4.953c-.162.016-.32.047-.485.047zm12.051-1.465a5 5 0 0 1-1.051.781V17a1 1 0 0 1 1-1h4.316a5 5 0 0 1-.781 1.051zM8.361 9.463c-.16.899-1.019 1.552-2.04 1.552-.826 0-1.603-.333-2.13-.914a.624.624 0 1 1 .925-.84c.286.316.736.504 1.204.504.448 0 .764-.265.81-.521.062-.345-.451-.562-.61-.621-.752-.277-1.43-.58-1.43-.58-.6-.382-.864-.969-.777-1.579.094-.649.568-1.178 1.239-1.38 1.317-.397 2.407.499 2.452.537l.003.002a.62.62 0 0 1 .076.876l-.005.005a.62.62 0 0 1-.875.076c-.025-.021-.633-.495-1.29-.299-.293.088-.351.282-.362.361a.3.3 0 0 0 .13.302c.016 0 .614.263 1.272.506 1.223.451 1.529 1.335 1.408 2.013M14 9.099V7c0-1.094.891-1.985 2-1.985a2.03 2.03 0 0 1 1.772 1.079.628.628 0 0 1-.554.921.63.63 0 0 1-.555-.341.78.78 0 0 0-.662-.409.74.74 0 0 0-.749.751v2.067c0 .449.358.751.749.751.408-.007.75-.34.75-.735v-.084h-.25a.5.5 0 0 1 0-1h.75a.75.75 0 0 1 .75.75v.334c0 1.09-.896 1.977-2 1.984a1.99 1.99 0 0 1-2-1.984zm-1.013-3.353-.969 4.645a.785.785 0 0 1-1.529.032L9.318 5.771a.607.607 0 1 1 1.177-.296l.71 2.823.583-2.799a.61.61 0 0 1 .594-.483h.012c.385 0 .673.354.594.731z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-svg_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSvg;
